<template>
  <b-card class="card" no-body>
    <div class="template">
      <img class="icon" :src="icon">
      <b-card-text class="title">
        {{ title }}
      </b-card-text>
      <b-card-text class="description">
        {{ description }}
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'IconCard',
  components: {
    BCard
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
    .icon {
        height: 99px;
        width: 99px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 13px;
    }

    .title {
        margin-bottom: 8px;
        color: #48465B;
        opacity: 1;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        white-space: pre-line;
    }

    .description {
        font-size: 14px;
        text-align: center;
        color: #9392A0;
        white-space: pre-line;
    }

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        height: 100%;
        padding: 28px;
    }

    .template {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: hidden;
    }
</style>
